import { useSessionContext } from '@/contexts/session/context';
import CreateGroup from '@/pages/messages/components/groups/group-create';
import AddContactsModal from '@/pages/contacts/components/add-contacts-modal';
import UsersIcon from '@/assets/images/common/svg/users.svg?react';
import MsgIcon from '@/assets/images/common/svg/msg.svg?react';
import { useChatContext } from '@/contexts/chat/context';
import PersonalCenter from '../personalCenter';
import MoreIcon from './images/more.svg?react';
import AddIcon from './images/add.svg?react';
import OnlineIcon from './images/online.svg?react';
import OfflineIcon from './images/offline.svg?react';
import ConnectingIcon from './images/connecting.svg?react';
import styles from './index.module.scss';

const UserInfo = () => {
  const { session } = useSessionContext();
  const [openCreateGroup, setOpenCreateGroup] = useState(false);
  const [openAddContacts, setOpenAddContacts] = useState(false);
  const { chatSocket } = useChatContext();

  return (
    <div className={styles.userInfoWrapper}>
      <PersonalCenter>
        <div className={styles.avatar}>
          <img src={session?.user?.avatar} />
          <div className={styles.status}>
            {chatSocket.loading ? (
              <ConnectingIcon></ConnectingIcon>
            ) : chatSocket.socket ? (
              <OnlineIcon />
            ) : (
              <OfflineIcon />
            )}
          </div>
        </div>
      </PersonalCenter>
      <div className={styles.info}>
        <div className={styles.top}>
          <div className={styles.name}>{session?.user?.name}</div>
          {/* <Badge count={2}></Badge> */}
          <MoreIcon />
        </div>
        {/* <div className={styles.bottom}>
          <div className={styles.coin}>Kelas.eth</div>
          <div className={styles.divider}></div>
          <div className={styles.status}>
            <img />
            Drinking coffee
          </div>
        </div> */}
      </div>
      <Popover
        arrow={false}
        placement="bottomRight"
        content={
          <div className={styles.addPopover}>
            <Button
              type="text"
              size="small"
              block
              style={{ justifyContent: 'flex-start' }}
              onClick={() => setOpenAddContacts(true)}
              icon={<UsersIcon />}
            >
              Add Contacts
            </Button>
            <Button
              type="text"
              size="small"
              block
              style={{ justifyContent: 'flex-start' }}
              onClick={() => setOpenCreateGroup(true)}
              icon={<MsgIcon />}
            >
              New Group
            </Button>
          </div>
        }
      >
        <div className={styles.addBtn}>
          <AddIcon />
        </div>
      </Popover>
      <CreateGroup open={openCreateGroup} onCancel={() => setOpenCreateGroup(false)} />
      <AddContactsModal
        open={openAddContacts}
        onCancel={() => setOpenAddContacts(false)}
      />
    </div>
  );
};

export default UserInfo;
